export const LOGO_VARIANTS = {
  en: {
    light: '/images/logos/logo-en-light.svg',
    dark: '/images/logos/logo-en-dark.svg'
  },
  ar: {
    light: '/images/logos/logo-ar-light.svg',
    dark: '/images/logos/logo-ar-dark.svg'
  }
};

const DEFAULT_LANGUAGE = 'en';

export const normalizeLanguage = (language) => {
  if (typeof language !== 'string' || language.length === 0) {
    return DEFAULT_LANGUAGE;
  }

  const normalized = language.toLowerCase().split(/[-_]/)[0];
  return LOGO_VARIANTS[normalized] ? normalized : DEFAULT_LANGUAGE;
};

export const getLogoVariant = (language) => {
  const normalized = normalizeLanguage(language);
  return LOGO_VARIANTS[normalized] || LOGO_VARIANTS[DEFAULT_LANGUAGE];
};
